import { z } from "zod";

const state = z.enum(["START", "IN_PROGRESS", "COMPLETED"]);

export const tvOrchestrator = z.object({
  type: z.literal("NJU_TV_SERVICE"),
  state,
  id: z.string(),
  userId: z.string().optional(),
  msisdnVerificationRequired: z.boolean().optional(),
});

export type ITvOrchestrator = z.infer<typeof tvOrchestrator>;
